var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMintscanButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3D3D4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1549 15.7575L7.62376 11.3734C7.56066 11.2641 7.52744 11.1402 7.52744 11.014C7.52744 10.8878 7.56066 10.7638 7.62376 10.6545L10.1549 6.27254C10.218 6.16325 10.3088 6.0725 10.4181 6.0094C10.5274 5.9463 10.6514 5.91308 10.7776 5.91309H15.8378C15.964 5.91308 16.088 5.9463 16.1973 6.0094C16.3065 6.0725 16.3973 6.16325 16.4604 6.27254L19.0001 10.6588L17.7549 11.3777L15.4312 7.35519H11.1927L9.07656 11.0182L11.4002 15.0429L10.1549 15.7575Z",
    fill: "#8A99AE",
    stroke: "#8A99AE",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8652 18.1429H8.79424C8.66804 18.1429 8.54407 18.1097 8.43477 18.0466C8.32548 17.9835 8.23472 17.8927 8.17162 17.7834L5.64258 13.4036L6.8857 12.6847L9.20933 16.7093H13.4372L15.5512 13.0441L13.2297 9.02166L14.4728 8.30273L17.004 12.6847C17.0671 12.794 17.1003 12.918 17.1003 13.0441C17.1003 13.1703 17.0671 13.2943 17.004 13.4036L14.4728 17.7877C14.4108 17.8943 14.3222 17.983 14.2157 18.0453C14.1093 18.1075 13.9885 18.1411 13.8652 18.1429Z",
    fill: "#8A99AE",
    stroke: "#8A99AE",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintscanButton);
export default __webpack_public_path__ + "static/media/MintscanButton.0721e002c6ffc372553a446eea7c38ba.svg";
export { ForwardRef as ReactComponent };